import { useState, useEffect, useRef } from "react";

// Helper functions (copiate da App.js)
const save = (key, val) => { try { localStorage.setItem(key, JSON.stringify(val)); } catch(e) {} };
const load = (key, def) => { try { const v = localStorage.getItem(key); return v ? JSON.parse(v) : def; } catch(e) { return def; } };

const UI = {
  textPrimary: "#e8e0d0", textSecondary: "#b0a898", textMuted: "#7a7068",
  border: "rgba(255,255,255,0.12)", borderSubtle: "rgba(255,255,255,0.07)",
};

function renderMarkdown(text) {
  if (!text) return null;
  return text.split("\n").map((line, i, arr) => {
    const parts = [];
    const regex = /(\*\*\*(.+?)\*\*\*|\*\*(.+?)\*\*|\*(.+?)\*|`(.+?)`)/g;
    let last = 0, m;
    while ((m = regex.exec(line)) !== null) {
      if (m.index > last) parts.push(<span key={last}>{line.slice(last, m.index)}</span>);
      if (m[2]) parts.push(<strong key={m.index}><em>{m[2]}</em></strong>);
      else if (m[3]) parts.push(<strong key={m.index}>{m[3]}</strong>);
      else if (m[4] || m[5]) parts.push(<em key={m.index}>{m[4]||m[5]}</em>);
      else if (m[6]) parts.push(<code key={m.index} style={{background:"rgba(255,255,255,0.1)",padding:"1px 5px",borderRadius:"3px",fontSize:"12px"}}>{m[6]}</code>);
      last = m.index + m[0].length;
    }
    if (last < line.length) parts.push(<span key={last}>{line.slice(last)}</span>);
    return <span key={i}>{parts.length > 0 ? parts : line}{i < arr.length - 1 && <br/>}</span>;
  });
}

// ============================================================
// IL CREATORE — Chat meta-AI per configurazione e gestione app
// ============================================================
// ============================================================
// IL CREATORE — Assistente configurazione on-demand
// ============================================================
function IlCreatore({ apiKey, apiBase, prompts, setPrompts, codexItems, setCodexItems, chats, summaryCompact, keyMoments, episodeCounters, fullscreen }) {

  const CODEX_SCHEMA = {
    personaggio: { nome:"", eta:"", nazionalita:"", altezza:"", professione:"", aspetto:"", carattere:"", paure:"", ruolo:"", note:"", protagonista:false, fiammaGemella:false, includePOV:false },
    luogo: { nome:"", citta:"", paese:"", tipo:"", descrizione:"", atmosfera:"", note:"" },
    relazione: { personaggioA:"", personaggioB:"", tipo:"", descrizione:"", dinamica:"", note:"" },
    lore: { nome:"", categoria:"", descrizione:"", note:"" },
    regola: { nome:"", categoria:"", descrizione:"", note:"" },
    altro: { nome:"", descrizione:"", note:"" }
  };

  const SYSTEM_PROMPT = `Sei "Il Creatore" — l'assistente di configurazione dell'app narrativa "La Nostra Storia — Nadia & Liam". Rispondi SEMPRE in italiano. Sei preciso, efficiente e non ridondante.

═══════════════════════════════════════
IL TUO RUOLO
═══════════════════════════════════════
Aiuti l'utente a:
1. Inserire e aggiornare elementi nel Codex (personaggi, luoghi, relazioni, lore, regole)
2. Modificare i prompt delle sezioni dell'app
3. Spiegare come funziona l'app

REGOLA FONDAMENTALE: Agisci SOLO quando l'utente usa trigger espliciti come:
- "inserisci nel Codex", "aggiungi al Codex", "carica questo file", "aggiorna il Codex"
- "modifica il prompt di [sezione]", "migliora il prompt di [sezione]"
- "spiega [funzione]", "come funziona [sezione]"

Se l'utente ti manda solo un file o testo senza trigger, chiedi: "Cosa vuoi che faccia con questo materiale?"

═══════════════════════════════════════
REGOLE ASSOLUTE — DA NON VIOLARE MAI
═══════════════════════════════════════

❌ VIETATO ASSOLUTO:
1. NON usare MAI conoscenze esterne — anche se conosci il personaggio nella realtà, IGNORA tutto quello che sai. Usa SOLO il testo del file.
2. NON abbreviare MAI — se nel file c'è un paragrafo di 200 parole, nel Codex ci vanno 200 parole, non un riassunto.
3. NON parafrasare MAI — copia il testo esatto, parola per parola.
4. NON inventare MAI campi vuoti — se un'informazione non è nel file, il campo resta vuoto.
5. NON saltare MAI parti del file — leggi tutto dall'inizio alla fine, nessuna sezione può essere ignorata.
6. NON fare mai di testa tua — zero iniziativa personale, zero interpretazioni.

✅ OBBLIGATORIO:
1. Leggi il file COMPLETO prima di fare qualsiasi cosa.
2. Copia il testo ESATTAMENTE come scritto nel file — virgola per virgola.
3. Tutto ciò che non ha un campo specifico va nel campo "altreCoseImportanti" — NIENTE viene perso.
4. Se hai dubbi su dove mettere qualcosa, mettila in "altreCoseImportanti".
5. Dopo aver inserito, elenca TUTTO quello che hai inserito campo per campo così l'utente può verificare.

ESEMPIO CONCRETO:
- File dice: "Capelli scuri quasi neri, portati con cura disordinata"
- GIUSTO → aspetto: "Capelli scuri quasi neri, portati con cura disordinata"
- SBAGLIATO → aspetto: "Capelli scuri" (abbreviato)
- SBAGLIATO → aspetto: "Capelli neri lisci e lucidi" (inventato da conoscenze esterne)

═══════════════════════════════════════
STRUTTURA APP
═══════════════════════════════════════
5 sezioni: RACCONTO (episodi narrativi, POV, Context Bridge), LAB (consulente, Blocchi Canon su richiesta), STYLIST (outfit, no Canon), INTIMO (erotica, POV, Context Bridge), MESSAGGI (WhatsApp tra personaggi).
Codex: personaggio, luogo, relazione, lore, regola, altro, fiammegemella (cronologia).
Ogni sezione ha un prompt modificabile. I modelli usati: Claude Sonnet per Racconto, DeepSeek per Lab/Intimo/Messaggi, Mistral per Stylist.

═══════════════════════════════════════
SCHEMA CODEX — CAMPI ESATTI
═══════════════════════════════════════
PERSONAGGIO: nome, eta, dataNascita(dd/mm/YYYY), nazionalita, provenienza, cittaAttuale, altezza, professione, aspetto, carattere, paure, presenzaIncontestabile, famigliaPassato, ruolo, coseDaSapere, note, altreCoseImportanti, protagonista(bool), fiammaGemella(bool), includePOV(bool)
LUOGO: nome, citta, paese, tipo, descrizione, atmosfera, note
RELAZIONE: personaggioA, personaggioB, tipo, descrizione, dinamica, note
LORE: nome, categoria(Spiritualità & Anime/Telepatia & Connessione/Segnali & Sincronicità/Dinamiche soprannaturali/Altro), descrizione, note
REGOLA: nome, categoria(POV & Narrazione/Tono & Stile/Struttura episodi/Continuità narrativa/Altro), descrizione, note
ALTRO: nome, descrizione, note

Il campo del contenuto si chiama SEMPRE "descrizione" — mai "testo", mai "contenuto".

IMPORTANTE: Se un file contiene informazioni su un personaggio che non corrispondono a nessun campo specifico (es: abitudini particolari, citazioni, dettagli unici), inseriscile nel campo "altreCoseImportanti". Non perdere mai informazioni — se non sai dove metterle, mettile lì.

═══════════════════════════════════════
COME INSERIRE NEL CODEX
═══════════════════════════════════════
Quando ricevi un file da inserire nel Codex:

PASSO 1 — Leggi il file COMPLETO dall'inizio alla fine.
PASSO 2 — Identifica tutti i campi e mappali ai campi del Codex.
PASSO 3 — Inserisci IMMEDIATAMENTE con il formato tag, senza chiedere conferme.
PASSO 4 — Dopo l'inserimento mostra solo un riepilogo compatto: "✅ Inserito: [tipo] — [nome]" con l'elenco dei campi caricati.

NON chiedere mai conferma prima di inserire.
NON elencare i campi prima di inserire.
NON fare domande preliminari — carica subito e basta.
Se manca solo la categoria, scegli tu quella più appropriata basandoti sul contenuto.

REGOLA SUL CAMPO "altreCoseImportanti":
Qualsiasi informazione nel file che non corrisponde a campi specifici va OBBLIGATORIAMENTE in "altreCoseImportanti". Non perdere MAI nulla.

Formato tag OBBLIGATORIO — usa ESATTAMENTE questo formato, nient'altro:
[CODEX:tipo]
{"nome":"...","campo1":"...","campo2":"..."}
[/CODEX:tipo]

ESEMPIO OBBLIGATORIO per un personaggio:
[CODEX:personaggio]
{"nome":"Mario Rossi","eta":"30","dataNascita":"01/01/1994","nazionalita":"Italiano","provenienza":"Roma","cittaAttuale":"Milano","altezza":"1,80","professione":"Avvocato","aspetto":"...","carattere":"...","paure":"...","presenzaIncontestabile":"...","famigliaPassato":"...","ruolo":"...","coseDaSapere":"...","note":"...","altreCoseImportanti":"...","protagonista":false,"fiammaGemella":false,"includePOV":false}
[/CODEX:personaggio]

NON usare liste puntate.
NON usare formato "- campo: valore".
USA SOLO il formato JSON tra tag [CODEX:...] e [/CODEX:...].
Il tag di chiusura [/CODEX:tipo] è OBBLIGATORIO — non dimenticarlo mai.

Tipi validi: personaggio, luogo, relazione, lore, regola, altro

═══════════════════════════════════════
COME MODIFICARE UN PROMPT
═══════════════════════════════════════
Leggi il prompt attuale SOLO se l'utente chiede di modificarlo.
Se l'utente fornisce un prompt da inserire, inseriscilo ESATTAMENTE come è scritto.
Solo se dice "miglioralo" o "riscrivilo" puoi modificarlo.
Formato tag per aggiornare:
[PROMPT:sezione]
testo completo del prompt — identico all'originale se non diversamente richiesto
[/PROMPT:sezione]
Sezioni: racconto, lab, stylist, intimo, messaggi

═══════════════════════════════════════
STILE DI RISPOSTA
═══════════════════════════════════════
- Le tue risposte nella chat devono essere brevi e dirette
- MA il contenuto che inserisci nel Codex deve essere COMPLETO e FEDELE — mai abbreviare, mai riassumere
- Se inserisci nel Codex, mostra solo: "✅ Inserito: [tipo] — [nome]"
- Se mancano informazioni, fai UNA domanda alla volta
- Non spiegare mai quello che stai per fare, fallo e basta
- Non ripetere il contenuto del file nella chat
- Se un campo del Codex deve contenere 500 caratteri, inserisci tutti e 500 — non tagliare

═══════════════════════════════════════
LETTURA E AGGIORNAMENTO CODEX ESISTENTE
═══════════════════════════════════════
Il Codex contiene tutti gli elementi del progetto (personaggi, luoghi, relazioni, lore, regole). È disponibile nel contesto sotto "CODEX COMPLETO" SOLO quando l'utente chiede qualcosa che lo riguarda.

Quando il Codex è nel contesto puoi:
- Rispondere a domande su elementi specifici (es. "chi è Zayn", "cosa dice la regola X")
- Elencare personaggi, luoghi, relazioni ecc.
- Aggiornare elementi esistenti usando il loro id:
  [CODEX:tipo|id_elemento]
  {"campo":"nuovo valore"}
  [/CODEX:tipo]
- Creare relazioni tra personaggi usando i nomi esatti dal Codex

Quando il Codex NON è nel contesto e l'utente chiede info su di esso, digli: "Puoi chiedermi specificamente cosa vuoi sapere dal Codex e lo cercherò per te."`;

  const username = load("s_auth_user", "admin");
  const welcomeMsg = { role: "assistant", content: "Ciao! Sono **Il Creatore**.\n\nDimmi cosa vuoi fare:\n- 📚 Inserire materiale nel Codex\n- 📝 Modificare un prompt\n- ❓ Capire come funziona una sezione\n\nPuoi anche allegare un file con 📎 e dirmi cosa fare con esso.", timestamp: Date.now() };

  const [messages, setMessages] = useState([welcomeMsg]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingFile, setLoadingFile] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [backendLoaded, setBackendLoaded] = useState(false);
  const abortRef = useRef(null);
  const endRef = useRef(null);
  const fileInputRef = useRef(null);
  const saveTimerRef = useRef(null);

  useEffect(() => {
    fetch(`/api/creatore/${username}`)
      .then(r => r.json())
      .then(data => {
        const clean = (data.messages || []).filter(m => !m.streaming && m.content !== "");
        if (clean.length > 0) setMessages(clean);
        setBackendLoaded(true);
      })
      .catch(() => setBackendLoaded(true));
  }, []);

  useEffect(() => {
    if (!backendLoaded) return;
    if (saveTimerRef.current) clearTimeout(saveTimerRef.current);
    saveTimerRef.current = setTimeout(() => {
      const toSave = messages.filter(m => !m.streaming).slice(-50);
      fetch(`/api/creatore/${username}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ messages: toSave })
      }).catch(() => {});
    }, 2000);
    return () => clearTimeout(saveTimerRef.current);
  }, [messages, backendLoaded]);

  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [messages]);

  // Legge prompt e Codex on-demand
  const getPromptContext = (text) => {
    let extra = "";
    const t = text.toLowerCase();

    // Legge prompt sezione solo se richiesto esplicitamente
    const sections = ['racconto', 'lab', 'stylist', 'intimo', 'messaggi'];
    for (const sec of sections) {
      if (t.includes(sec) && (t.includes('prompt') || t.includes('modifica') || t.includes('migliora') || t.includes('aggiorna'))) {
        extra += `\n\nPROMPT ATTUALE DI ${sec.toUpperCase()}:\n${(prompts||{})[sec] || "Non disponibile"}`;
        break;
      }
    }

    // Passa il Codex solo se l'utente chiede esplicitamente
    const codexTriggers = [
      'chi è', 'dimmi', 'cosa dice', 'elenca', 'mostrami', 'lista',
      'personaggi', 'quanti', 'quali', 'c\'è nel codex', 'nel codex',
      'relazione tra', 'crea una relazione', 'aggiorna', 'modifica la scheda',
      'ruolo di', 'carattere di', 'scheda di', 'regola', 'lore',
      'tutti i personaggi', 'tutti i luoghi', 'tutti i'
    ];
    const needsCodex = codexTriggers.some(k => t.includes(k));

    if (needsCodex && codexItems?.length > 0) {
      extra += `\n\nCODEX COMPLETO (${codexItems.length} elementi):\n`;
      codexItems.forEach(item => {
        extra += `\n--- [${(item.type||'').toUpperCase()}] id:${item.id} ---\n`;
        const skip = ['id','type','createdAt','foto','cronologia'];
        Object.entries(item).forEach(([k,v]) => {
          if (!skip.includes(k) && v !== undefined && v !== null && v !== '' && v !== false) {
            extra += `${k}: ${typeof v === 'object' ? JSON.stringify(v) : v}\n`;
          }
        });
      });
    }

    return extra;
  };

  const parseAndApply = (text) => {
    let applied = [];

    // Applica prompt
    const promptRegex = /\[PROMPT:(\w+)\]([\s\S]*?)\[\/PROMPT:\1\]/g;
    let m;
    while ((m = promptRegex.exec(text)) !== null) {
      const sec = m[1];
      const newPrompt = m[2].trim();
      if (prompts?.hasOwnProperty(sec)) {
        setPrompts(p => ({ ...p, [sec]: newPrompt }));
        applied.push({ type: 'prompt', name: sec });
      }
    }

    // Applica codex — supporta tag senza chiusura (es. Qwen)
    console.log("FULL RESPONSE:", text.slice(0, 500));
    console.log("HAS CODEX TAG:", text.includes("[CODEX:"));
    console.log("HAS CLOSING TAG:", text.includes("[/CODEX:"));
    console.log("FULL TEXT LENGTH:", text.length);

    // Normalizza: se manca il tag di chiusura lo aggiunge
    let normalizedText = text;
    const openTags = text.match(/\[CODEX:[\w_]+(?:\|[^\]]*)?\]/g) || [];
    const closeTags = text.match(/\[\/CODEX:[\w_]+\]/g) || [];
    if (openTags.length > closeTags.length) {
      // Aggiunge tag di chiusura mancanti alla fine
      openTags.forEach((tag, i) => {
        if (i >= closeTags.length) {
          const tipo = tag.match(/\[CODEX:([\w_]+)/)?.[1] || 'altro';
          normalizedText += `\n[/CODEX:${tipo}]`;
        }
      });
    }

    const codexRegex = /\[CODEX:([\w_]+)(?:\|([^\]]*))?\]([\s\S]*?)\[\/CODEX:[\w_]+\]/g;
    let codexText = normalizedText;
    while ((m = codexRegex.exec(codexText)) !== null) {
      const tipoRaw = m[1].toLowerCase().replace(/_/g, '');
      const tipoMap = { personaggio:'personaggio', luogo:'luogo', relazione:'relazione', lore:'lore', regola:'regola', regolanarativa:'regola', narrativa:'regola', altro:'altro', fiammagemella:'fiammegemella', fiammegemelle:'fiammegemella' };
      const tipo = tipoMap[tipoRaw] || tipoRaw;
      const existingId = m[2]?.trim();
      const rawData = m[3].trim();
      const cleanData = rawData.replace(/[\u201C\u201D]/g, '"').replace(/[\u2018\u2019]/g, "'");
      try {
        let data;
        try { data = JSON.parse(cleanData); } catch {}
        if (!data) { const jm = cleanData.match(/\{[\s\S]*\}/); if (jm) { try { data = JSON.parse(jm[0]); } catch {} } }
        if (!data) throw new Error("No JSON");
        const id = existingId || `cx${Date.now()}_${Math.random().toString(36).slice(2,6)}`;
        const newItem = { id, type: tipo, ...data, createdAt: Date.now() };
        if (existingId && codexItems.find(i => i.id === existingId)) {
          setCodexItems(p => p.map(i => i.id === existingId ? { ...i, ...data } : i));
        } else {
          setCodexItems(p => [...p, newItem]);
        }
        applied.push({ type: 'codex', kind: tipo, name: data.nome || tipo });
      } catch(e) { console.warn("Codex parse error:", e.message, cleanData.slice(0,100)); }
    }
    return applied;
  };

  const sendMessage = async () => {
    if (!input.trim() && uploadedFiles.length === 0) return;
    if (!apiKey) { alert("Configura prima l'API Key."); return; }

    // Costruisce testo utente — NON include il contenuto del file nel messaggio visibile
    let userText = input.trim();
    let systemExtra = "";

    if (uploadedFiles.length > 0) {
      // Aggiunge contenuto file solo al contesto sistema — non visibile in chat
      systemExtra = "\n\n═══════════════════════════════════════\nFILE ALLEGATI DALL'UTENTE (analizza silenziosamente):\n═══════════════════════════════════════\n";
      uploadedFiles.forEach(f => {
        if (!f.type?.startsWith("image/")) {
          systemExtra += `\n--- ${f.name} ---\n${(f.text || "").slice(0, 20000)}\n`;
        }
      });
    }

    const userMsg = {
      role: "user",
      content: userText || `[File allegato: ${uploadedFiles.map(f=>f.name).join(", ")}]`,
      files: uploadedFiles.map(f => f.name),
      timestamp: Date.now()
    };

    const newMessages = [...messages, userMsg];
    setMessages(newMessages);
    setInput(""); setUploadedFiles([]); setLoading(true);

    const streamId = `cr_${Date.now()}`;
    setMessages(p => [...p, { role: "assistant", content: "", id: streamId, streaming: true, timestamp: Date.now() }]);
    abortRef.current = new AbortController();

    try {
      // Legge prompt solo se richiesto
      const promptContext = getPromptContext(userText);

      const history = newMessages.slice(-10).map((msg, i) => ({
        role: msg.role,
        content: i === newMessages.length - 1
          ? (userText || `[File: ${userMsg.files.join(", ")}]`)
          : (msg.content || "")
      }));

      const fullSystemPrompt = SYSTEM_PROMPT + promptContext + systemExtra;

      const res = await fetch(`${apiBase}/chat/completions`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${apiKey}`,
          "HTTP-Referer": window.location.href,
          "X-Title": "La Nostra Storia - Il Creatore"
        },
        signal: abortRef.current.signal,
        body: JSON.stringify({
          model: "anthropic/claude-haiku-4-5",
          messages: [{ role: "system", content: fullSystemPrompt }, ...history],
          max_tokens: 4000,
          stream: true
        })
      });

      const reader = res.body.getReader();
      const decoder = new TextDecoder();
      let fullText = "";

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        const chunk = decoder.decode(value);
        const lines = chunk.split("\n").filter(l => l.startsWith("data: ") && l !== "data: [DONE]");
        for (const line of lines) {
          try {
            const json = JSON.parse(line.slice(6));
            const delta = json.choices?.[0]?.delta?.content || "";
            fullText += delta;
            setMessages(p => p.map(m => m.id === streamId ? { ...m, content: fullText } : m));
          } catch {}
        }
      }

      const applied = parseAndApply(fullText);
      setMessages(p => p.map(m => m.id === streamId ? { ...m, streaming: false, appliedChanges: applied } : m));

    } catch(e) {
      const errMsg = e.name === "AbortError" ? "" : "Connessione interrotta. Riprova.";
      setMessages(p => p.map(m => m.id === streamId ? { ...m, content: errMsg, streaming: false } : m));
    }
    setLoading(false);
  };

  const handleFileUpload = async (e) => {
    const files = Array.from(e.target.files);
    setLoadingFile(true);

    if (!window.mammoth) {
      await new Promise((resolve) => {
        const script = document.createElement("script");
        script.src = "https://cdn.jsdelivr.net/npm/mammoth@1.6.0/mammoth.browser.min.js";
        script.onload = resolve; script.onerror = resolve;
        document.head.appendChild(script);
      });
    }

    const processed = await Promise.all(files.map(async file => {
      if (file.type.startsWith("image/")) {
        return new Promise(res => {
          const r = new FileReader();
          r.onload = e => res({ name: file.name, type: file.type, data: e.target.result });
          r.readAsDataURL(file);
        });
      }
      if (file.name.endsWith(".docx") || file.name.endsWith(".doc")) {
        return new Promise(res => {
          const r = new FileReader();
          r.onload = async (e) => {
            try {
              if (window.mammoth) {
                const result = await window.mammoth.extractRawText({ arrayBuffer: e.target.result });
                res({ name: file.name, type: file.type, text: result.value });
              } else {
                const decoder = new TextDecoder("utf-8", { fatal: false });
                const clean = decoder.decode(e.target.result).replace(/[^\x20-\x7E\u00A0-\u024F\n\r\t]/g, " ").replace(/\s+/g, " ").trim();
                res({ name: file.name, type: file.type, text: clean.slice(0, 50000) });
              }
            } catch(err) { res({ name: file.name, type: file.type, text: "" }); }
          };
          r.readAsArrayBuffer(file);
        });
      }
      return new Promise(res => {
        const r = new FileReader();
        r.onload = e => res({ name: file.name, type: file.type, text: e.target.result });
        r.readAsText(file, "UTF-8");
      });
    }));

    setUploadedFiles(p => [...p, ...processed]);
    setLoadingFile(false);
    e.target.value = "";
  };

  const color = "#c97eb8";

  // Mostra riepilogo applicazioni
  const renderApplied = (changes) => {
    if (!changes?.length) return null;
    return (
      <div style={{ marginTop: "10px", padding: "8px 12px", background: "rgba(142,201,160,0.1)", border: "1px solid rgba(142,201,160,0.25)", borderRadius: "6px" }}>
        {changes.map((c, i) => (
          <div key={i} style={{ fontSize: "12px", color: "#8ec9a0" }}>
            {c.type === 'codex' ? `✅ Inserito nel Codex: ${c.kind} — ${c.name}` : `✅ Prompt aggiornato: ${c.name}`}
          </div>
        ))}
      </div>
    );
  };

  return (
    <div style={{ width: fullscreen ? "100%" : "50%", flexShrink: 0, borderLeft: fullscreen ? "none" : "1px solid rgba(201,126,184,0.2)", background: "rgba(201,126,184,0.02)", display: "flex", flexDirection: "column", overflow: "hidden", flex: fullscreen ? 1 : undefined }}>
      {/* Header */}
      <div style={{ padding: "14px 18px 10px", borderBottom: "1px solid rgba(201,126,184,0.15)", display: "flex", alignItems: "center", gap: "10px" }}>
        <span style={{ fontSize: "18px" }}>✨</span>
        <div style={{ flex: 1 }}>
          <h3 style={{ color, fontSize: "13px", letterSpacing: "2px", textTransform: "uppercase", fontWeight: "normal", margin: 0 }}>Il Creatore</h3>
          <p style={{ fontSize: "10px", color: UI.textMuted, margin: 0 }}>Assistente configurazione — solo su richiesta</p>
        </div>
        <button onClick={() => {
          const w = [welcomeMsg];
          setMessages(w);
          fetch(`/api/creatore/${username}`, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({messages: w}) }).catch(()=>{});
        }} style={{ background: "none", border: `1px solid ${UI.borderSubtle}`, borderRadius: "6px", padding: "4px 8px", cursor: "pointer", fontSize: "10px", color: UI.textMuted, fontFamily: "Georgia, serif" }}>
          🗑️ Azzera
        </button>
      </div>

      {/* Messaggi */}
      <div style={{ flex: 1, overflowY: "auto", padding: "14px", display: "flex", flexDirection: "column", gap: "10px" }}>
        {messages.map((msg, i) => (
          <div key={i} style={{ display: "flex", flexDirection: "column", alignItems: msg.role === "user" ? "flex-end" : "flex-start", gap: "4px" }}>
            {msg.files?.length > 0 && (
              <div style={{ display: "flex", flexWrap: "wrap", gap: "4px", justifyContent: "flex-end" }}>
                {msg.files.map(f => <span key={f} style={{ fontSize: "10px", color: color, background: `${color}15`, border: `1px solid ${color}30`, borderRadius: "4px", padding: "2px 6px" }}>📎 {f}</span>)}
              </div>
            )}
            <div style={{ maxWidth: "92%", padding: "10px 14px", borderRadius: msg.role === "user" ? "14px 14px 4px 14px" : "4px 14px 14px 14px", background: msg.role === "user" ? `${color}20` : "rgba(255,255,255,0.04)", border: `1px solid ${msg.role === "user" ? `${color}35` : UI.borderSubtle}`, fontSize: "13px", color: UI.textPrimary, lineHeight: "1.7", wordBreak: "break-word" }}>
              {msg.streaming && !msg.content
                ? <span style={{ color: UI.textMuted, fontStyle: "italic" }}>Il Creatore sta scrivendo...</span>
                : renderMarkdown(
                    (msg.content || "")
                      .replace(/\[PROMPT:\w+\][\s\S]*?\[\/PROMPT:\w+\]/g, "")
                      .replace(/\[CODEX:[\w_]+(?:\|[^\]]*)?\][\s\S]*?\[\/CODEX:[\w_]+\]/g, "")
                      .trim()
                  )
              }
              {renderApplied(msg.appliedChanges)}
            </div>
          </div>
        ))}
        <div ref={endRef} />
      </div>

      {/* File caricati */}
      {(uploadedFiles.length > 0 || loadingFile) && (
        <div style={{ padding: "6px 14px", borderTop: `1px solid ${UI.borderSubtle}`, display: "flex", flexWrap: "wrap", gap: "4px", alignItems: "center" }}>
          {loadingFile && <span style={{ fontSize: "11px", color: color, fontStyle: "italic" }}>📖 Lettura file in corso...</span>}
          {uploadedFiles.map((f, i) => (
            <div key={i} style={{ display: "flex", alignItems: "center", gap: "4px", background: `${color}15`, border: `1px solid ${color}30`, borderRadius: "4px", padding: "3px 8px" }}>
              <span style={{ fontSize: "11px", color: color }}>📎 {f.name}</span>
              <button onClick={() => setUploadedFiles(p => p.filter((_, j) => j !== i))} style={{ background: "none", border: "none", color: UI.textMuted, cursor: "pointer", fontSize: "11px", padding: 0 }}>✕</button>
            </div>
          ))}
        </div>
      )}

      {/* Input */}
      <div style={{ padding: "10px 14px 14px", borderTop: "1px solid rgba(201,126,184,0.15)", display: "flex", gap: "6px", alignItems: "flex-end" }}>
        <input type="file" ref={fileInputRef} onChange={handleFileUpload} multiple accept=".txt,.md,.docx,.doc,.pdf,.png,.jpg,.jpeg" style={{ display: "none" }} />
        <button onClick={() => fileInputRef.current?.click()} title="Allega file" style={{ background: "none", border: `1px solid ${UI.borderSubtle}`, borderRadius: "8px", width: "36px", height: "36px", cursor: "pointer", fontSize: "15px", color: UI.textMuted, flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>📎</button>
        <textarea
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={e => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); sendMessage(); } }}
          placeholder="Es: inserisci nel Codex, modifica il prompt di Lab..."
          style={{ flex: 1, background: "rgba(255,255,255,0.04)", border: `1px solid ${UI.border}`, borderRadius: "8px", padding: "9px 12px", color: UI.textPrimary, fontSize: "13px", fontFamily: "Georgia, serif", resize: "none", minHeight: "72px", maxHeight: "160px", lineHeight: "1.6", outline: "none" }}
          rows={3}
        />
        {loading
          ? <button onClick={() => { abortRef.current?.abort(); setLoading(false); }} style={{ background: "rgba(224,120,120,0.2)", border: "1px solid rgba(224,120,120,0.5)", borderRadius: "8px", width: "36px", height: "36px", cursor: "pointer", fontSize: "14px", color: "#e07878", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>■</button>
          : <button onClick={sendMessage} disabled={!input.trim() && uploadedFiles.length === 0} style={{ background: input.trim() || uploadedFiles.length > 0 ? color : `${color}18`, border: "none", borderRadius: "8px", width: "36px", height: "36px", cursor: input.trim() || uploadedFiles.length > 0 ? "pointer" : "not-allowed", fontSize: "16px", color: input.trim() || uploadedFiles.length > 0 ? "#0a0a0f" : color, flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>→</button>
        }
      </div>
    </div>
  );
}

export default IlCreatore;